export default {
  name: "Foreign Worker Group",
  sections: [
    {
      isProfileLinkingTable: true,
      type: "foreign-worker-group",
      linkingType: "foreign-worker",
      searchType: "foreign-worker-search",
      addButtonText: "Add Foreign Worker Profiles to this Group",
    },
    {
      name: "Profile Group",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_group_fw_profiles",
          widget: "text",
          hidden: true,
        },
        {
          machine_name: "new_group_fw_group_name",
          widget: "text",
          label: "What would you like to name this group?",
          maxLength: 50,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this group",
        },
      ],
    },
  ],
};
